import {combineReducers} from 'redux'
import Immutable from 'seamless-immutable'
import {get, isNil} from 'lodash'
import {createPivotTableReducer} from 'reducers/pivotTable'
import {types} from 'actions/priceLists'
import nonPrefixedTypes from '../../../actions/types'

const open = (state = false, action) => {
  switch (action.type) {
    case types.SHOW_SELECTOR:
      return true
    case types.HIDE_SELECTOR:
      return false
    default:
      return state
  }
}

const priceListId = (state = null, action) => {
  switch (action.type) {
    case types.SELECT_ALL_PRICE_LISTS:
      return null
    case types.SEARCH_CATEGORIES:
      return null
    case types.SELECT_PRICE_LIST:
      return action.priceListId
    case types.SELECT_CATEGORY:
      return action.category.priceListId
    case nonPrefixedTypes.PRICE_LISTS_CHANGE_TOP_LEVEL_PART_CATEGORY:
      return action.partCategory.priceListId
    case nonPrefixedTypes.PRICE_LISTS_LOAD_PART_CATEGORY_SUCCESS:
      return action.data.priceListId
    default:
      return state
  }
}

const category = (state = null, action) => {
  switch (action.type) {
    case types.SELECT_ALL_PRICE_LISTS:
      return null
    case types.SELECT_PRICE_LIST:
      return null
    case types.SEARCH_CATEGORIES:
      return null
    case types.SELECT_CATEGORY:
      return action.category
    case nonPrefixedTypes.PRICE_LISTS_CHANGE_TOP_LEVEL_PART_CATEGORY:
      return action.partCategory
    case nonPrefixedTypes.PRICE_LISTS_LOAD_PART_CATEGORY_SUCCESS:
      return action.data
    case nonPrefixedTypes.PRICE_LISTS_SHOW_PART_CATEGORY_DIALOG:
      const category = get(action, 'category', null)

      if (isNil(category))
        return state

      return category
    case nonPrefixedTypes.PRICE_LISTS_PART_CATEGORY_UPDATE_SUCCESS:
      if (isNil(state))
        return state

      return state.id === action.data.id
        ? action.data
        : state
    default:
      return state
  }
}

const categoryId = (state = null, action) => {
  switch (action.type) {
    case types.SELECT_ALL_PRICE_LISTS:
      return null
    case types.SELECT_PRICE_LIST:
      return null
    case types.SEARCH_CATEGORIES:
      return null
    case types.SELECT_CATEGORY:
      return action.category.id
    case nonPrefixedTypes.PRICE_LISTS_CHANGE_TOP_LEVEL_PART_CATEGORY:
      return action.partCategory.id
    case nonPrefixedTypes.PRICE_LISTS_LOAD_PART_CATEGORY_SUCCESS:
      return action.data.id
    case nonPrefixedTypes.PRICE_LISTS_PART_CATEGORY_UPDATE_SUCCESS:
      if (isNil(state))
        return state

      return state.id === action.data.id
        ? action.data.id
        : state
    default:
      return state
  }
}

const partSupplierCompanyId = (state = null, action) => {
  switch (action.type) {
    case types.PRICE_LISTS_SELECT_PART_SUPPLIER:
      return action.companyId
    default:
      return state
  }
}

const search = (state = '', action) => {
  switch (action.type) {
    case types.SELECT_ALL_PRICE_LISTS:
      return ''
    case types.SEARCH_CATEGORIES:
      return action.search ? action.search : ''
    default:
      return state
  }
}

const showDormants = (state = Immutable(false), action) => {
  switch (action.type) {
    case types.UPDATE_PART_FILTERS:
      return get(action, 'filters.showDormants', state)
    default:
      return state
  }
}

export const partsPivotTableKey = 'priceListsContext.parts.parts'

export default combineReducers({
  open,
  priceListId,
  category,
  categoryId,
  partSupplierCompanyId,
  search,
  showDormants,
  parts: createPivotTableReducer({key: partsPivotTableKey, defaultSortColumn: 'partCode'}),
})
